import { StateCreator } from "zustand"

import type * as StoreTypes from "@src/types/store"
import { Message } from "@src/types"

const initState = {
  messages: [],
}

export const createMessagesSlice: StateCreator<StoreTypes.StoreState, [], [], StoreTypes.MessagesSlice> = (
  set,
  get,
) => ({
  ...initState,
  addMessage: (message: Message) => {
    set((state) => ({
      messages: [...state.messages, message],
    }))
  },
  updateMessage: (id: string, updates: Partial<Message>) => {
    set((state) => ({
      messages: state.messages.map((message) => (message.id === id ? { ...message, ...updates } : message)),
    }))
  },
  deleteMessage: (id: string) => {
    set((state) => ({
      messages: state.messages.filter((message) => message.id !== id),
    }))
  },
  getScheduledMessages: () => {
    const state = get()
    return state.messages.filter(
      (message) => message.scheduledDate && new Date(message.scheduledDate) > new Date(),
    )
  },
  resetMessages: () => {
    set({ ...initState })
  },
})
